import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const QualificationConfigs = () => {
  const [degreeTypes, setDegreeTypes] = useState([]);
  const [docTypes, setDocTypes] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/degree-types").then(setDegreeTypes).catch(() => {});
    apiJson("/api/admin/master/document-types").then(setDocTypes).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Academic Qualification Configs"
      apiPath="/api/admin/master/qualification-configs"
      columns={[
        { key: "id", label: "ID" },
        { label: "Degree Type", render: (item) => item.degreeType?.name || "-" },
        { key: "admissionType", label: "Admission Type" },
        { key: "degreeCycle", label: "Cycle" },
        { key: "label", label: "Label" },
        { label: "Linked Document", render: (item) => item.documentType?.name || "—" },
        { key: "sortOrder", label: "Sort" },
        { key: "isRequired", label: "Required" },
      ]}
      formFields={[
        {
          key: "degreeTypeId",
          label: "Degree Type",
          type: "select",
          required: true,
          options: degreeTypes.map((d) => ({ value: d.id, label: d.name })),
        },
        {
          key: "admissionType",
          label: "Admission Type",
          type: "select",
          required: true,
          options: [
            { value: "FRESH", label: "FRESH" },
            { value: "ROLLOVER", label: "ROLLOVER" },
          ],
        },
        { key: "degreeCycle", label: "Degree Cycle (blank = any)", type: "number" },
        { key: "label", label: "Label (e.g. 10th, Sem 1 Marksheet)", required: true },
        {
          key: "documentTypeId",
          label: "Linked Document Type (blank = none)",
          type: "select",
          options: [{ value: "", label: "— None —" }, ...docTypes.map((d) => ({ value: d.id, label: d.name }))],
        },
        { key: "sortOrder", label: "Sort Order", type: "number" },
        { key: "isRequired", label: "Required", type: "checkbox", defaultValue: true },
      ]}
    />
  );
};

export default QualificationConfigs;
